import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { MarkerAddress, MarkerSize, MarkerType } from '@design-system/components/molecules/marker/entities/marker.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-marker',
  templateUrl: './marker.component.html',
  styleUrls: ['./marker.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent,
  ]
})
export class MarkerDsComponent {

  @Input() size = MarkerSize.MD;
  @Input() type = MarkerType.Default;
  @Input() label: string;
  @Input() icon: Icon;
  @Input() address: MarkerAddress;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly typographyFontFamily = TypographyFontFamily;
  public readonly typographyFontSize = TypographyFontSize;
  public readonly typographyColorSecondary = TypographyColor.Secondary;

  public readonly closeIcon = Icon.Close;
  public readonly locationIcon = Icon.Location;

  public isOpenLocationTag = true;

  constructor() { }

  get isLocationMarker(): boolean {
    return this.type === MarkerType.Location;
  }

  get fontSize(): TypographyFontSize {
    return this.size === MarkerSize.MD ? TypographyFontSize.XXS :
      this.size === MarkerSize.RG ? TypographyFontSize.XXXS : TypographyFontSize.Minor;
  }

  get fontColor(): TypographyColor {
    return this.isLocationMarker ? TypographyColor.Primary : TypographyColor.Invert;
  }

  get iconColor(): IconFillColor {
    return this.isLocationMarker ? IconFillColor.Primary : IconFillColor.Light;
  }

  get iconSize(): number {
    return this.size === MarkerSize.MD ? 16 : this.size === MarkerSize.RG ? 14 : 12;
  }

  public setOpenLocation(): void {
    this.isOpenLocationTag = !this.isOpenLocationTag;
  }

  public closeLocation(e: Event): void {
    e?.preventDefault();
    e?.stopPropagation();
    this.setOpenLocation();
  }

  public clickEventEmit(): void {
    if (this.type !== MarkerType.Location) {
      this.clickEvent.emit();
    } else if (!this.isOpenLocationTag) {
      this.setOpenLocation();
    }
  }

}
